import React from 'react'
import { FormGroup, Row, Col } from 'react-bootstrap'
import { TextBox } from 'fw/forms'
import { Label } from 'fw/components'
import { ZipCodeAuto, StateCombo, CountryCombo } from 'areas/shared/controls'

const USA_COUNTRY_CODE = "USA";
const USA_MILITARY_BASES_ZIP = "938";

class Address extends React.Component {

	constructor(props) {
		super(props);

		this.state = this.initialState(props);
	}

	initialState(props) {
		if (!props.value) {
			return {
				value: this.initValue()
			}
		}
		else {
			let zip = props.value.zip != null ? props.value.zip.substring(0,3) : "";
			return {
				value: {
					internationalMode: !props.onlyUSA && (props.value.countryCode !== USA_COUNTRY_CODE && zip !== USA_MILITARY_BASES_ZIP),
					addressId: props.value.addressId || 0,
					street1: props.value.street1 || "",
					street2: props.value.street2 || "",
					city: props.value.city || "",
					province: props.value.province,
					zip: props.value.zip || "",
					zipName: props.value.zipName || "",
					county: props.value.county || "",
					stateCode: props.value.stateCode,
					countryCode: props.onlyUSA ? USA_COUNTRY_CODE : props.value.countryCode,
					residential: props.value.residential
				}
			};
		}
	}

	initValue() {
		return {
			addressId: 0,
			street1: "",
			street2: "",
			city: "",
			province: "",
			zip: "",
			zipName: "",
			county: "",
			stateCode: "",
			countryCode: USA_COUNTRY_CODE,
			internationalMode: false,
			residential: false,
			onlyUSA: false
		}
	}

	// Events
	register = (_form) => {
        if (_form){
            for (var ref in this.refs) {
                _form.register(this.refs[ref]);
            }
        }
	}
	
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt(this);
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	// Private
	_update = (value) => {		
		const me = this;

		this.setState({ value }, function () {
			this.onDirt();
			// If managed by forms, trigger field change, then change
			if (this.props.managed) {				
				// Set city, county, state and country based on zip code.
				if (this.props.name.toLowerCase().indexOf('address') >= 0 && value.zipName) {
					const res = value.zipName.split(' - ');
					if (res.length > 4) {
						value.city = res[1].trim();
						value.county = res[2].trim();
						value.stateCode = res[3].trim();
						value.countryCode = res[4].trim();					
					} else {
						value.countryCode = "USA";
					}
				}

				this.props.onFieldChange(value, this.props.name, function () { me.onChange(value); });
			}
			else
				// If not, only trigger this comp change
				this.onChange(value);
		});
	}

	_handleChange = (value) => {
		this._update(value);
	}

	_handleZipChange = (v) => {
		if (v != null)
			this._handleChange({ ...this.state.value, zip: v.value, zipName: v.label })
		else
			this._handleChange({ ...this.state.value, zip: "", zipName: "", city: "", county: "", stateCode: null, countryCode: "USA" })
	}

	_handleCountryChange = (value) => {
		this._update(
			{
				...this.state.value,
				internationalMode: (value !== USA_COUNTRY_CODE && this.state.value.zip.substring(0,3) !== USA_MILITARY_BASES_ZIP),
				zip: "", zipName: "", city: "", county: "", province: "", stateCode: null, countryCode: value
			});
	}

	getRequest(selectedId) {
		return {
			zipCodeId: selectedId
		}
	}

	// React
	componentWillReceiveProps(nextProps) {
		// If receiving null from the parent form, set state to default
		if (nextProps.value == null) {
			this.setState(this.initValue());
			return;
		}

		// Update state to reflect props
		if (nextProps.disabled !== this.state.disabled) {
			this.setState({
				disabled: nextProps.disabled
			});
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextState.value !== this.state.value
			|| nextProps.disabled !== this.props.disabled);
	}

	render() {
		const a = this.state.value;

		return (
			<React.Fragment>
				<Row>
					<Col md={12}>
						<FormGroup>
							<Label required={this.props.required}>{this.props.titles.streets}</Label>
							{this.props.showResidential &&
								<label
									className="inline pull-right"
									style={{
										fontWeight: "normal",
										fontSize: "12px",
										cursor: "pointer"
									}}>
									<span style={{ marginRight: "5px" }}>
										{this.props.titles.residential}
									</span>
									<input
										type="checkbox"
										checked={a.residential}
										onChange={(e) => this._handleChange({ ...this.state.value, residential: e.target.checked })} />
								</label>
							}
							<TextBox
								value={a.street1}
								maxLength={30}
								disabled={this.props.disabled}
								placeholder={this.props.placeholders.street1}
								onChange={(v) => this._handleChange({ ...this.state.value, street1: v })} 
								ref={`${this.props.name}_street1`}
								required={this.props.required}
							/>
							<TextBox
								value={a.street2}
								maxLength={30}
								disabled={this.props.disabled}
								style={{ marginTop: "3px" }}
								placeholder={this.props.placeholders.street2}
								onChange={(v) => this._handleChange({ ...this.state.value, street2: v })} />
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						{!this.state.value.internationalMode &&
							<FormGroup>
								<Label htmlFor="zip" required={this.props.required}>{this.props.titles.zip}</Label>
								<ZipCodeAuto
									clearable
									disabled={this.props.disabled}
									value={a.zip}
									text={a.zip}
									placeholder={this.props.placeholders.zip}
									maxLength={10}
									onChange={(v) => { this._handleZipChange(v) }}
									ref={`${this.props.name}_zip`}
									required={this.props.required}
								/>
							</FormGroup>
						}
						{this.state.value.internationalMode &&
							<FormGroup>
								<Label required={this.props.required}>{this.props.titles.zip}</Label>
								<TextBox
									value={a.zip}
									disabled={this.props.disabled}
									placeholder={this.props.placeholders.zip}
									onChange={(v) => this._handleChange({ ...this.state.value, zip: v })} 
									ref={`${this.props.name}_zip`}
									required={this.props.required}
								/>
							</FormGroup>
						}
					</Col>
					<Col md={6}>
						<FormGroup>
							<Label required={this.props.required}>{this.props.titles.city}</Label>
							<TextBox
								value={a.city}
								maxLength={30}
								disabled={this.props.disabled}
								placeholder={this.props.placeholders.city}
								onChange={(v) => this._handleChange({ ...this.state.value, city: v })}
								ref={`${this.props.name}_city`}
								required={this.props.required}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<Label>{this.props.titles.county}</Label>
							<TextBox
								value={a.county}
								maxLength={30}
								disabled={this.props.disabled}
								placeholder={this.props.placeholders.county}
								onChange={(v) => this._handleChange({ ...this.state.value, county: v })} />
						</FormGroup>
					</Col>
					<Col md={6}>
						{!this.state.value.internationalMode &&
							<FormGroup>
								<Label required={this.props.required}>{this.props.titles.state}</Label>
								<StateCombo
									value={a.stateCode}
									disabled={this.props.disabled}
									placeholder={this.props.placeholders.state}
									onChange={(v) => this._handleChange({ ...this.state.value, stateCode: v.value })}
									ref={`${this.props.name}_stateCode`}
									required={this.props.required}
								/>
							</FormGroup>
						}
						{this.state.value.internationalMode &&
							<FormGroup>
								<Label required={this.props.required}>{this.props.titles.province}</Label>
								<TextBox
									value={a.province}
									disabled={this.props.disabled}
									placeholder={this.props.placeholders.province}
									onChange={(v) => this._handleChange({ ...this.state.value, province: v })}
									ref={`${this.props.name}_province`}
									required={this.props.required}
								/>
							</FormGroup>
						}
					</Col>
				</Row>
				<Row>
					<Col md={12}>
						<FormGroup>
							<Label required={this.props.required}>{this.props.titles.country}</Label>
							<CountryCombo
								value={a.countryCode}
								menuHeight={120}
								disabled={this.props.disabled || this.props.onlyUSA}
								placeholder={this.props.placeholders.country}
								onChange={(v) => this._handleCountryChange(v.value)}
								ref={`${this.props.name}_country`}
								required={this.props.required}
							/>
						</FormGroup>
					</Col>
				</Row>
			</React.Fragment>
		);
	}
}

export default Address;

// Mark this as a form component
Address.defaultProps = {
	formControl: true,
	managed: false,
	required: false,
	showResidential: false,
	onlyUSA: false,
	value: {
		addressId: 0,
		street1: "",
		street2: "",
		city: "",
		state: "",
		stateCode: "",
		county: "",
		countryCode: USA_COUNTRY_CODE,
		residential: false
	},
	titles: {
		streets: "Street Address",
		city: "City",
		zip: "Zip / Postal Code",
		state: "State",
		country: "Country",
		county: "County",
		postalCode: "Postal Code",
		province: "Province",
		residential: "RESIDENTIAL"
	},
	placeholders: {
		street1: "Street 1",
		street2: "Street 2",
		city: "City",
		zip: "Zip / PC",
		county: "County",
		state: "State...",
		country: "Country...",
		postalCode: "Postal Code",
		province: "Province"
	}
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/address/Address.js